import React from 'react';

import StatusCell from '../../../components/Badge/StatusCell';
import InfoGrayIcon from '../../../components/Icons/InfoGrayIcon';
import ResolveConflictModal from '../../../components/Modal/ModalActions/ResolveConflictModal/ResolveConflictModal';
import Table from '../../../components/Table/Table';
import ActionRowWithModal from '../../../components/Table/TableAccessories/ActionRowWithModal';
import TableDateTimeFormatter from '../../../components/Table/TableAccessories/TableDateTimeFormatter';
import TableNameCapitalizeFormatter from '../../../components/Table/TableAccessories/TableNameCapitalizeFormatter';
import TablePhoneFormatter from '../../../components/Table/TableAccessories/TablePhoneFormatter';
import ConflictResponseRowCell from '../../../components/Table/TableMobileRowCell/ConflictResponseRowCell';

const ConflictsResponseList = () => {
  return (
    <>
      <Table
        // border
        // tableTitle='Incident Reports'
        // hasClickableRow
        // clickRowAction={(rowData: any) => {
        //   return navigate(`/${DRIVER_PERFORMANCE_REPORT}`, {
        //     state: { data: rowData },
        //   });
        // }}
        tableFilterBoxFeatures={{
          showSearchBox: true,
          searchBoxPlaceholder: 'Search driver name...',
        }}
        tableHeader={{
          Date: 'createdAt',
          'Driver Name': 'driverName',
          'Company Name': 'companyName',
          'Conflict Response': 'conflictIssue',
        }}
        tableDataSourceUrl='api/v1/company/hiring-conflicts/responses'
        cellsCustomComp={{
          createdAt: <TableDateTimeFormatter dataKey='createdAt' />,
          status: <StatusCell statusKey='status' />,
          phoneNumber: <TablePhoneFormatter dataKey='phoneNumber' />,
          name: <TableNameCapitalizeFormatter dataKey='name' />,
        }}
        moreOptionsComponents={[
          <ActionRowWithModal
            key='Resolve Issue'
            label='Resolve Issue'
            width='257px'
            icon={<InfoGrayIcon />}
            modalCompFn={(data) => <ResolveConflictModal data={data} />}
          />,
        ]}
        mobileCellComp={<ConflictResponseRowCell />}
        // showPaginationControl={false}
      />
    </>
  );
};

export default ConflictsResponseList;
